




















































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import slugify from 'slugify';
import _ from 'lodash';
import FileSaver from 'file-saver';
import axios from 'axios';

import * as WRAPPERS_QUERY from 'src/graphql/admin/Wrappers.graphql';

@Component({
  apollo: {
    wrappers: {
      query: WRAPPERS_QUERY,
      fetchPolicy: 'cache-and-network',
    },
  }
})
export default class extends Vue {
  reportId = "";
  wrapper = "";
  wrappers = [];
  fetchingReport = false;
  fetchingWrapper = false;
  statusReport = [];
  statusWrapper = [];

  async onDownloadReport() {
    this.statusReport = [];

    let regexUuid = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
    if (!regexUuid.test(this.reportId)) {
      // Make it more obvious we checked the format again.
      setTimeout(() => {
        this.statusReport = ['The Report ID is not in the correct format'];
      }, 10);
      return;
    }

    this.fetchingReport = true;

    try {
      const config = {
        headers: {'Authorization': 'Bearer ' + this.$store.state.auth.accessToken},
        responseType: 'blob',
      };

      const res = await axios.get(`/downloadReport/${this.reportId}`, config);

      if (res.status === 204) {
        this.statusReport = ['The report contains no simulation results'];
      } else {
        const disposition = res.headers['content-disposition']
        const filename = decodeURI(disposition.match(/filename="(.*)"/)[1])
        console.log(`Saving report zip as ${filename}`);

        FileSaver.saveAs(res.data, filename);
      }
    } catch (e) {
      if (e.response && e.response.status === 404) {
        this.statusReport = ['The report could not be found'];
      } else {
        this.$store.commit('setError', {
          msg: e.response,
          permissionError: false,
        });
      }
    } finally {
      this.fetchingReport = false;
    }
  }

  async onDownloadWrapper() {
    this.statusWrapper = [];
    this.fetchingWrapper = true;

    try {
      const config = {
        headers: {'Authorization': 'Bearer ' + this.$store.state.auth.accessToken},
        responseType: 'blob',
      };

      const res = await axios.get(`/downloadWrapper/${this.wrapper}`, config);

      const disposition = res.headers['content-disposition']
      const filename = decodeURI(disposition.match(/filename="(.*)"/)[1])
      console.log(`Downloading wrapper zip as ${filename}`);

      FileSaver.saveAs(res.data, filename);
    } catch (e) {
      if (e.response && e.response.status === 404) {
        this.statusWrapper = ['The wrapper could not be found'];
      } else {
        this.$store.commit('setError', {
          msg: e.response,
          permissionError: false,
        });
      }
    } finally {
      this.fetchingWrapper = false;
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/admin/ProjectDownload.vue